// Lifetimes for self-deleting posts, in seconds. The server needs at least
// ten minutes.

const HOUR = 3600
const DAY = 24 * HOUR
const WEEK = 7 * DAY

export const EXPIRY_CHOICES = [HOUR, 6 * HOUR, DAY, 3 * DAY, WEEK]
export const DEFAULT_EXPIRY = DAY

// '1 hour', '3 days', '1 week', in the given language
export const expiryLabel = (seconds, locale) => {
  const [value, unit] =
    seconds % WEEK === 0
      ? [seconds / WEEK, 'week']
      : seconds % DAY === 0
        ? [seconds / DAY, 'day']
        : [seconds / HOUR, 'hour']
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit,
    unitDisplay: 'long',
  }).format(value)
}
